var React = require('react');

function CommandLineIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M42 4H6a2 2 0 0 0-2 2v36a2 2 0 0 0 2 2h36a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zM6 0a6 6 0 0 0-6 6v36a6 6 0 0 0 6 6h36a6 6 0 0 0 6-6V6a6 6 0 0 0-6-6H6zm4.586 18.586a2 2 0 0 1 2.828 0L22.828 28l-9.414 9.414a2 2 0 1 1-2.828-2.828L17.172 28l-6.586-6.586a2 2 0 0 1 0-2.828zM36 34h-9a2 2 0 0 0 0 4h9a2 2 0 0 0 0-4z","fill":"#9A77FF"}));
}

CommandLineIcon.defaultProps = {"width":"48","height":"48","viewBox":"0 0 48 48","fill":"none"};

module.exports = CommandLineIcon;

CommandLineIcon.default = CommandLineIcon;
